import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { ProspectionForm } from "../components";

export const CreateProspection: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  return (
    <>
      <Header
        title="Prospection"
        subtitle="Enregistrer une nouvelle prospection"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/prospections`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle prospection" />
          <ProspectionForm
            customerId={customerId ? +customerId : undefined}
            onCompleted={() => navigate("/prospections")}
          />
        </div>
      </div>
    </>
  );
};
